import React, { useEffect, useState, useContext } from "react";
import Navbar from "./Navbar/index";
import Header from "./Header/Header";
import Licences from "./License/index";
import Statisctic from "./Statistics";
import SayAboutUs from "./SayAboutUs";
import UserMostLike from "./UserMostLike";
import ChatBox from "./components/ChatBox";
import Footer from "./Footer/Footer";
import { useParams } from "react-router-dom";
import Axios from "axios";
import AppContext from "../../../context/store";
import TimeIsUp from "../Campaigns/TimeIsUp/TimeIsUp";
import Videos from "./Videos/Videos";
import LicenceManagement from "./LicenceManagement/LicenceManagement";

function CampaignsPageIndex() {
  const [timeIsUP, setTimeIsUP] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const [packages, setPackages] = useState([]);
  const { token } = useParams();
  const context = useContext(AppContext);

  useEffect(() => {
    if (token) {
      async function test() {
        await Axios.post(`${context.api_endpoint}/first`, {
          token,
          getPackets: true,
        })
          .then((data) => {
            setTimeLeft(Number(data.data.data.ttl));
            setPackages(data.data.data.campaignPackets);
          })
          .catch((err) => {
            if (err.response.status) {
              setTimeIsUP(true);
            }
          });
      }
      test();
    } else {
    }
  }, [token]);

  return !timeIsUP ? (
    <div style={{ position: "relative" }}>
      <ChatBox />
      <Navbar timeLeft={timeLeft} setTimeLeft={setTimeLeft} />
      {process.env.APP_NAME === "management" ? (
        <LicenceManagement packages={packages} token={token} />
      ) : (
        <Licences packages={packages} token={token} />
      )}
      <Header />
      {process.env.APP_NAME === "salon" && <Videos />}
      <UserMostLike />
      <SayAboutUs />
      <Footer />
      <Statisctic />
    </div>
  ) : (
    <TimeIsUp />
  );
}

export default CampaignsPageIndex;
